import React from "react";
import { lightTheme } from "@backstage/theme";
import { ThemeProviderOverride } from "../providers";

// @TODO - Fix Typing Issues
export const radiatorLightTheme: any = {
  ...lightTheme,
  title: "Default Light Theme",
  variant: "light" as "light",
  id: "default",
  Provider: ({ children }: { children: React.ReactNode }) => (
    <ThemeProviderOverride theme={radiatorLightTheme}>
      {children}
    </ThemeProviderOverride>
  ),
};
